// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"352":"447eb5c373309155","455":"278bd2847c854678","834":"821db59eb79a00ac","845":"f043ec933cb34515","887":"7a52d9ae1b29b966"}[chunkId] + ".js";
};